import {
  Info,
  OctagonX,
  ShieldCheck,
  Sparkle,
  TriangleAlert,
} from "lucide-react";
import { Toaster as Sonner, toast as sonnerToast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;
type ToastOptions = Parameters<typeof sonnerToast>[1];

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    toastOptions={{
      classNames: {
        error:
          "!bg-error !text-error [&>button]:!bg-button-danger [&>button]:!text-white",
        success:
          "!bg-success !text-success [&>button]:!bg-button-primary [&>button]:!text-white",
        info: "!bg-info !text-info [&>button]:!bg-button-info [&>button]:!text-button-info",
        toast:
          "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        warning:
          "!bg-warning !text-warning [&>button]:!bg-button-warning [&>button]:!text-white",
        closeButton: "!h-3 !w-3 !top-[10px] !left-[10px] !absolute",
      },
    }}
    // This sets all of the icons to empty divs so that they don't show up. If you want to use an icon, you can
    // pass the icon in when invoking the toast.
    icons={{
      info: <Info />,
      error: <OctagonX />,
      success: <ShieldCheck />,
      warning: <TriangleAlert />,
    }}
    closeButton
    {...props}
  />
);

const toast = Object.assign(sonnerToast, {
  // Styles are hardcoded for superclinical, be sure to extend if adding additional partners
  superclinical: (message: string, options?: ToastOptions) => {
    return sonnerToast(message, {
      icon: <Sparkle />,
      className:
        "!bg-superclinical !text-superclinical !shadow-lg [&>button]:!bg-button-superclinical [&>button]:!text-white",
      ...options,
    });
  },
});

export { Toaster, toast };
